export const getUnixTime = () => Math.round(+new Date() / 1000);
